export default __webpack_public_path__ + "static/media/ic-details.00eb2847.svg";